export enum Permission {
  ARCGIS_CIVIL3D_SETTINGS = 'ArcGIS - Civil 3D Settings',
  ARCGIS_FEATURE_CLASSES = 'ArcGIS Feature Classes',
  ARCGIS_SCHEMAS = 'ArcGIS Schemas',
  AASHTOWARE = 'Aashtoware',
  CONTRACTS = 'Contracts',
  CIVIL_3D_TEMPLATES = 'Civil 3D Templates',
  DOMAINS = 'Domains',
  EVENT_LOG = 'Event Log',
  EXPORT = 'Export',
  FEATURE_TYPES = 'Feature types',
  ONTOLOGY = 'Ontology',
  ROLES = 'Roles',
  SETTINGS = 'Settings',
  STYLE_EDITOR = 'Style Editor',
  SYNC = 'Sync',
  USERS = 'Users',
}

export const fromOldPermission = (oldPermission: string) => {
  switch (oldPermission) {
    case 'Manage Aashtoware':
      return Permission.AASHTOWARE;
    case 'Manage Contracts':
      return Permission.CONTRACTS;
    case 'Manage Domains':
      return Permission.DOMAINS;
    case 'Manage Survey Codes':
    case 'Manage Survey Categories':
    case 'Manage Attributes':
    case 'Manage Attribute List Values':
      return Permission.ONTOLOGY;
    case 'Tools Menu':
    case 'Import FXL':
      return Permission.SYNC;
    case 'Styles Editor':
      return Permission.STYLE_EDITOR;
    case 'Export FXL':
    case 'Export Civil 3D':
    case 'Export GIS':
    case 'Export Microstation':
    case 'Export TBC':
    case 'Export REST API':
      return Permission.EXPORT;
    case 'Manage Permissions':
      return Permission.ROLES;
    case 'Manage Users':
      return Permission.USERS;
    case 'View Event Log':
      return Permission.EVENT_LOG;
    case 'System Menu':
      return Permission.SETTINGS;
    case 'Manage Attribute Types':
    case 'Manage Entry Methods':
    case 'Manage Feature Types':
      return Permission.FEATURE_TYPES;
    case 'Civil 3D Templates':
      return Permission.CIVIL_3D_TEMPLATES;
    case Permission.ARCGIS_FEATURE_CLASSES:
      return Permission.ARCGIS_FEATURE_CLASSES;
    case Permission.ARCGIS_CIVIL3D_SETTINGS:
      return Permission.ARCGIS_CIVIL3D_SETTINGS;
    case Permission.ARCGIS_SCHEMAS:
      return Permission.ARCGIS_SCHEMAS;
    default:
      return null;
  }
};
